import { SET_MESSAGE_ALERT_ACTION_TYPE } from './actions';

const defaultState = {
  message: null,
  maxWidth: 'xs',
  buttonText: null,
};

const AlertReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_MESSAGE_ALERT_ACTION_TYPE: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default AlertReducer;
